import EmailIcon from '../../../icons/email.svg'

export const EMAIL_SEARCH_ITEM_DATE_FORMAT = 'HH:mm, dd LLLL yyyy'

export const EMAIL_SEARCH_ITEM_ICON = { Icon: EmailIcon }
